import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { PIC_DEFAULT_PERMISSION, Role } from '../enums';
import { Helper } from '@app-shared/public-api';

export const roleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  const currentUser = authService.getCurrentUser();
  const { permission } = route.data;
  if (!currentUser) return false;
  if (!permission) return true;
  const isAllowAccess = Helper.checkAllowPermission(currentUser, permission);

  if (!isAllowAccess) {
    router.navigate(['/exception', '403']);
    return false;
  }
  return true;
};
